export default __webpack_public_path__ + "static/media/phonebooth_screen_background_lightOn.02b51b1f.webp";